import { $ } from '@/libs/jquery/index'

$.validator.addMethod('length', function(value: string, element: HTMLElement, params: string | number): boolean {
  // удаляем _, которые добавляет inputmask
  const parse = value.replace(/(_|\s)/g, '')

  const lengths = typeof params ===  'number'
    ? [params]
    : params.split(',').map((x) => parseInt(x, 10))

  return this.optional(element) || lengths.indexOf(parse.length) !== -1
}, 'Поле заполнено некорректно')
